import { useCallback, useEffect, useState } from "react"

import gsap from "gsap"
import styled from "styled-components"

import media from "styles/media"

interface Props {
  src: string[]
  className?: string
}

export default function LazyVideo({ src, className = "" }: Props) {
  const [vidSrc, setVidSrc] = useState<JSX.Element[] | null>(null)
  const [wrapper, setWrapper] = useState<HTMLDivElement | null>(null)

  const loadVideo = useCallback(async () => {
    const allVidSources = src.map(async vid => {
      const el = await import(`../../static/${vid}`)
      return el.default
    })

    const srcset = await Promise.all(
      allVidSources.map(async (vid, i, arr) => {
        const res = await vid
        return (
          <source
            key={res}
            src={res}
            type={arr.length > 1 && i === 0 ? "video/webm" : "video/mp4"}
          />
        )
      })
    )

    setVidSrc(srcset)
  }, [src])

  useEffect(() => {
    if (wrapper) {
      const tl = gsap.timeline({ scrollTrigger: wrapper, start: "top bottom" })

      tl.to(wrapper, {
        onStart: () => {
          loadVideo()
        },
      })
    }
  }, [src, loadVideo, wrapper])

  return (
    <VidWrapper ref={ref => setWrapper(ref)}>
      {vidSrc ? (
        <video className={className} autoPlay playsInline muted loop>
          {vidSrc}
        </video>
      ) : (
        <span className={className}>Loading...</span>
      )}
    </VidWrapper>
  )
}

const VidWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  video {
    position: absolute;
    width: 100%;
    object-fit: cover;

    ${media.fullWidth} {
      position: relative;
      width: 120%;
      left: -10%;
    }
  }
`
